module.exports = __webpack_public_path__ + "static/media/coffee-wifi.bf5aa4b5.svg";